export const paidGuides = [
  {
    slug: "f1-visa-guide",
    number: "01",
    icon: "ri-passport-line",
    title: "F-1ビザ申請実践ガイド",
    summary:
      "エージェントを使わずにF-1ビザを取得した準備の詳細を、書類チェックリストとスケジュール付きでまとめたPDFガイドです。",
    contents: [
      "運営者が実際に行った準備の詳細",
      "オリジナルの書類チェックリスト",
      "準備スケジュール（時系列）",
      "申請時につまずいた経験と対処方法",
      "面接準備に関する体験談",
    ],
    note: "体験談を中心としたガイドです。制度の最新情報は、必ず公式サイトで確認してください。",
  },
  {
    slug: "tsia2-guide",
    number: "02",
    icon: "ri-draft-line",
    title: "TSIA2対策・日本語解説ガイド",
    summary:
      "TSIA2に向けた勉強経験をもとに、数学の重要分野の日本語解説と、独自に作成した練習問題をまとめたPDFガイドです。",
    contents: [
      "実際の勉強経験とつまずいた分野",
      "数学の重要分野に関する日本語解説",
      "ELARの勉強方法",
      "独自に作成したオリジナル練習問題",
      "試験日から逆算した学習計画表",
      "復習チェックリスト",
    ],
    note: "公式の問題・練習問題の転載は含みません。掲載する練習問題はすべて独自に作成します。",
  },
  {
    slug: "preparation-guide",
    number: "03",
    icon: "ri-route-line",
    title: "コミカレ留学準備ガイド",
    summary:
      "大学探しから出願、渡米準備までの手順を、時系列のスケジュールとテンプレート付きでまとめたPDFガイドです。",
    contents: [
      "大学探しから出願までの詳しい準備手順",
      "留学準備の時系列スケジュール",
      "必要書類を管理するためのテンプレート",
      "学校を同じ観点で比べるための学校比較テンプレート",
      "実際の留学経験に基づくアドバイス",
      "渡米準備チェックリスト",
    ],
    note: "必要書類や締切は学校ごとに異なります。ガイドは準備の進め方を整理するための資料です。",
  },
];

// 販売ページ（noteなど）ができたら、ここにURLを入れると購入ボタンが有効になります。
export const guidePurchaseUrls: Record<string, string | null> = {
  "f1-visa-guide": null,
  "tsia2-guide": null,
  "preparation-guide": null,
};